/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeasurementUIDTOV0 } from './measurementUIDTOV0';


export interface EmissionFeatureUIDTOV0 { 
    emissionsSaved?: MeasurementUIDTOV0;
    emissionsCreated?: MeasurementUIDTOV0;
}

